import { ConfigProvider } from '@oviva-ag/configuration';

export function ConfigProviderWrapper({ children }: { children: React.ReactNode }) {
  const isEngageBuild = process.env.NEXT_PUBLIC_BUILD_TYPE === 'engage';

  const shouldUseConfigProvider = !isEngageBuild;

  if (shouldUseConfigProvider) {
    return <ConfigProvider path="/config.json">{children}</ConfigProvider>;
  }
  return <>{children}</>;
}
